import { CreateAgreementCmp } from '@/components/features/agreements/creation/CreateAgreementCmp'
import { NavHeader } from '../../components/features/shared/NavHeader'
import { PageContainer } from '@/components/features/shared/PageContainer'

interface CreateAgreementPageProps { }

export const CreateAgreementPage = ({ }: CreateAgreementPageProps) => {
  return (
    <PageContainer className='max-w-4xl'>
      <NavHeader>
        <h1 className="text-2xl font-bold tracking-tight text-center">Nueva Contratación</h1>
        <p className="text-muted-foreground">
          Creación de un nuevo contrato
        </p>
      </NavHeader>
      <CreateAgreementCmp />
    </PageContainer>
  )
}
